import httpClient from './httpClient';

const baseEndpoint = '/api/shop/item/smell'

const saveItemSmell = request => {
    return httpClient.post(`${baseEndpoint}/secure/save`, request)
}

const fetchAllItemSmells = () => {
    return httpClient.get(`${baseEndpoint}/secure/all`)
}

const fetchItemSmellsByItemId = itemId => {
    return httpClient.get(`${baseEndpoint}/all/item`, { params: { itemId } })
}

export {
    saveItemSmell,
    fetchAllItemSmells,
    fetchItemSmellsByItemId
}
